var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResearchAreaIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 17,
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.00195312 8.52539C0.00195312 4.10941 3.58597 0.525391 8.00195 0.525391C12.4179 0.525391 16.002 4.10941 16.002 8.52539C16.002 12.9414 12.4179 16.5254 8.00195 16.5254C3.58597 16.5254 0.00195312 12.9414 0.00195312 8.52539ZM1.60196 8.52539C1.60196 12.0534 4.47394 14.9254 8.00195 14.9254C9.51443 14.9254 10.9063 14.3975 12.0031 13.5164L10.1744 11.6914V11.2478L10.0228 11.0906C9.3826 11.6409 8.55148 11.9722 7.64737 11.9722C5.63135 11.9722 3.99719 10.3381 3.99719 8.32205C3.99719 6.30603 5.63135 4.67188 7.64737 4.67188C9.66339 4.67188 11.2975 6.30603 11.2975 8.32205C11.2975 9.22617 10.9662 10.0573 10.4159 10.6975L10.5731 10.8491H11.0168L12.8557 12.6917C13.819 11.5712 14.4019 10.1149 14.4019 8.52539C14.4019 4.99738 11.53 2.1254 8.00195 2.1254C4.47394 2.1254 1.60196 4.99738 1.60196 8.52539ZM5.12033 8.32205C5.12033 9.72034 6.24908 10.8491 7.64737 10.8491C9.04565 10.8491 10.1744 9.72034 10.1744 8.32205C10.1744 6.92377 9.04565 5.79501 7.64737 5.79501C6.24908 5.79501 5.12033 6.92377 5.12033 8.32205Z",
  fill: "#B7BDD1"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgResearchAreaIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/researchAreaIcon.3e8bdbbf0c03a02ec902c877df6d9323.svg";